export default "__VITE_ASSET__342bb8f4__"